import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import CategoryService from '../../services/categoryService';
import Category from '../../models/category';

export const BannerSearch = () => {
    let categories = new CategoryService().GetAll();
    let rapidSearchCategories = categories.filter(c => c.isRapidSearchType);

    const [selectedCategory, setSelectedCategory] = useState(0);
    const [inputSearch, setInputSearch] = useState('');

    const selectCategory = (event) => {
        setSelectedCategory(event.target.value)
    }
    return (
        <>
            { /*Banner*/}
            <div className="main-search-container plain-color">
                <div className="main-search-inner">

                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="main-search-headlines">
                                    <h2>
                                        No compres, alquila!!
                                        {/* <!-- Typed words can be configured in script settings at the bottom of this HTML file --> */}
                                        <span className="typed-words"></span>
                                    </h2>
                                    <h4>Para que comprar algo que sólo lo vas a usar una vez, piensa en el mundo y alquila</h4>
                                </div>

                                <div className="main-search-input">
                                    <div className="main-search-input-item">
                                        <select className="chosen-select" onChange={selectCategory} >
                                            <option key="all"  >Selecciona la categoria</option>
                                            {!!categories && categories.map((category) => (
                                                <option key={category.id}>{category.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="main-search-input-item">
                                        <input type="text"
                                         className="input-text"
                                         value={inputSearch}
                                         onChange={(e) => setInputSearch(e.target.value)}
                                          name="name" placeholder='Escribe aquí lo que estás buscando' />
                                    </div>
                                    {/* <button onClick="window.location.href='listings-half-screen-map-list.html'">Buscar</button> */}
                                    <Link className="button" to={`/list?category=${selectedCategory}&search=${inputSearch}`}>
                                        Buscar
                                    </Link>
                                </div>
                                {/* <!-- Features Categories --> */}
                                <div className="row">
                                    <div className="col-md-12">
                                        <h5 className="highlighted-categories-headline">O usa nuestra búsqueda rápida:</h5>

                                        <div>
                                            {/* <!-- Box --> */}
                                            {!!rapidSearchCategories && rapidSearchCategories.map((rapidSearchCategory) => (
                                                <Link key={rapidSearchCategory.id} to={`/list?category=${rapidSearchCategory.name}`} className="highlighted-category">
                                                    <i className="im im-icon-Home"></i>
                                                    <h4>{rapidSearchCategory.name}</h4>
                                                </Link>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- Featured Categories - End --> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
